import script from "./AnimatedEmoji.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedEmoji.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedEmoji.vue?vue&type=style&index=0&id=019872c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019872c2"]])

export default __exports__